:host {
  ::slotted(stzh-ratio),
  ::slotted(*) stzh-ratio {
    --ratio: #{16 / 9};
    --max-height: 680px;
    --overflow: hidden;

    @include mq($from: small) {
      --ratio: #{21 / 9};
    }

    @include mq($from: medium) {
      --ratio: #{21 / 9};
    }

    @include mq($from: large) {
      --ratio: #{21 / 9};
    }
  }
}

.stzh-vbz-carousel {

}
